import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmt } from "../lib/api";
import { useFetch } from "../lib/useFetch";
import { Panel, Spinner } from "./common";
import { Switch } from "./ui/switch";

const LABEL = { trend_pullback: "Trend pullback", breakout: "Breakout", range_reversion: "Range reversion" };
const tone = (h) => (h == null ? "text-slate-500" : h < 45 ? "text-red-600" : h < 55 ? "text-amber-600" : "text-emerald-600");

export const SetupPerformance = () => {
  const { data, reload } = useFetch("/signals/setup-performance");
  const [busy, setBusy] = useState(null);
  const toggle = async (r) => {
    setBusy(r.key);
    try {
      const s = await api.get("/settings");
      const cur = new Set(s.data.disabled_setups || []);
      if (r.enabled) cur.add(r.key); else cur.delete(r.key);
      await api.put("/settings", { disabled_setups: [...cur] });
      toast.success(`${r.market} · ${LABEL[r.setup]}: ${r.enabled ? "OFF (tidak aktif)" : "ON (aktif)"}`); reload();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <Panel title="BUY hit rate by market & setup · 30 days (1h)" className="mb-3" testid="setup-performance">
      {!data ? <Spinner /> : (
        <>
          <div className="custom-scrollbar overflow-x-auto"><table className="tbl w-full">
            <thead><tr><th>Market</th><th>Setup</th><th>BUY signals</th><th>Losers</th><th>Hit</th><th>Avg move since</th><th>Active</th></tr></thead>
            <tbody>{data.rows.map((r) => (
              <tr key={r.key} data-testid={`setup-row-${r.key}`} className={r.enabled ? "" : "opacity-60"}>
                <td className="mono">{r.market}</td><td>{LABEL[r.setup]}</td><td className="mono">{r.count}</td><td className="mono">{r.losers}</td>
                <td className={`mono font-bold ${tone(r.hit_pct)}`} data-testid={`setup-hit-${r.key}`}>{r.hit_pct == null ? "—" : `${r.hit_pct}%`}</td>
                <td className={`mono ${r.avg_move_pct > 0 ? "text-emerald-600" : r.avg_move_pct < 0 ? "text-red-600" : ""}`}>{r.avg_move_pct == null ? "—" : `${r.avg_move_pct > 0 ? "+" : ""}${fmt(r.avg_move_pct, 2)}%`}</td>
                <td><div className="flex items-center gap-2"><Switch checked={r.enabled} disabled={busy === r.key} onCheckedChange={() => toggle(r)} data-testid={`setup-switch-${r.key}`} />
                  <span className={`text-[10px] ${r.enabled ? "text-emerald-600" : "text-slate-500"}`} data-testid={`setup-state-${r.key}`}>{r.enabled ? "Aktif" : "Tidak aktif"}</span></div></td>
              </tr>))}
            </tbody></table></div>
          <p className="mt-2 text-[10px] text-slate-500">{data.note} Weakest first. Few signals (&lt;10) = not enough evidence to judge.</p>
        </>
      )}
    </Panel>
  );
};
